var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { modalId: "cancel-subscription-modal", size: "modal-md" },
          on: {
            hidden: function($event) {
              return _vm.closeManagePlanModal()
            }
          }
        },
        [
          _c(
            "ModalHeader",
            {
              style: { padding: "4px 12px" },
              attrs: {
                title: _vm.$t("xCancelPlan"),
                icon: "far fa-circle-dollar colorOrange mr-1"
              }
            },
            [
              _c("div", { staticClass: "cols-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: {
                      type: "button",
                      "data-test-hook": "CloseModalBtn"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeManagePlanModal()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "p",
                  { attrs: { "data-test-hook": "EndOfSubscriptionText" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("xCurrentPlanDateText")) +
                        " " +
                        _vm._s(
                          _vm.$moment(_vm.endDate).format("MM/DD/YYYY") + "."
                        ) +
                        " " +
                        _vm._s(_vm.$t("xCurrentPlanText")) +
                        " "
                    )
                  ]
                )
              ])
            ]),
            _vm.doesAccountHaveGen() && !_vm.doesAccountHaveFuelMonitor()
              ? _c("div", [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text",
                          attrs: {
                            "data-test-hook": "BasicFeaturesTextGenOnly"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xGenToReceiveBasicFeaturesText")) +
                              " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("xPremiumGenFeaturesHeader")))
                  ]),
                  _c("ul", [
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem1")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem2")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem3")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem4")))
                    ])
                  ])
                ])
              : !_vm.doesAccountHaveGen() && _vm.doesAccountHaveFuelMonitor()
              ? _c("div", [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text",
                          attrs: {
                            "data-test-hook": "BasicFeaturesTextMonitorOnly"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xMonitorToReceiveBasicFeaturesText")
                              ) +
                              " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("xPremiumFuelMonitorFeaturesHeader")))
                  ]),
                  _c("ul", [
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem1")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem2")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem3")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem4")))
                    ])
                  ])
                ])
              : _c("div", [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text",
                          attrs: {
                            "data-test-hook": "BasicFeaturesTextGenAndMonitor"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xGenAndMonitorBasicFeaturesText")
                              ) +
                              " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("xPremiumGenFeaturesHeader")))
                  ]),
                  _c("ul", [
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem1")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem2")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem3")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xGenPremiumFeaturesItem4")))
                    ])
                  ]),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("xPremiumFuelMonitorFeaturesHeader")))
                  ]),
                  _c("ul", [
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem1")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem2")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem3")))
                    ]),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("xMonitorPremiumFeaturesItem4")))
                    ])
                  ])
                ]),
            _c(
              "div",
              {
                staticClass: "row",
                attrs: { "data-test-hook": "AreYouSureYouWantToCancelText" }
              },
              [
                _c("div", { staticClass: "col" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("xAreYouSureYouWantToCancelText")) + " "
                  )
                ])
              ]
            )
          ]),
          _c("ModalFooter", [
            _c("div", { staticClass: "modal-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-warning",
                  attrs: {
                    type: "button",
                    title: _vm.$t("xManageYourPlan"),
                    "data-test-hook": "KeepPlanBtn"
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeManagePlanModal()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xKeepPlanButtonText")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-warning ml-2",
                  attrs: {
                    type: "button",
                    title: _vm.$t("xManageYourPlan"),
                    "data-test-hook": "CancelPlanBtn"
                  },
                  on: {
                    click: function($event) {
                      return _vm.cancelSubscription()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("xCancelPlanButtonText")) + " ")]
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            modalId: "cancel-subscription-spinner-modal",
            size: "modal-lg"
          }
        },
        [
          _c(
            "ModalBody",
            {
              staticStyle: { "padding-top": "100px", "padding-bottom": "100px" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center"
                },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "10rem", height: "10rem" },
                    attrs: { variant: "warning" }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }